import React from 'react';
import PropTypes from 'prop-types';

export default class Block extends React.Component {
  static propTypes = {
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    vRowSpacing: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    vColSpacing: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    hColSpacing: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    className: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element])
      .isRequired,
  };

  static defaultProps = {
    component: 'div',
    vRowSpacing: 'lg',
    vColSpacing: 'lg',
    hColSpacing: 'lg',
    className: undefined,
  };

  render() {
    const {
      component: Component,
      vRowSpacing,
      hColSpacing,
      vColSpacing,
      className,
      children,
    } = this.props;

    return (
      <Component className={className}>
        {React.Children.map(
          children,
          (child, index) =>
            child &&
            React.cloneElement(child, {
              key: index,
              vSpacing: vRowSpacing,
              vColSpacing,
              hColSpacing,
            })
        )}
      </Component>
    );
  }
}
